module.exports = __webpack_public_path__ + "static/img/lunbotu01.f9bd26ba.png";